import { GetServerSideProps } from "next";
import { StrapiCustomerService } from "~/shared-types";
import { findSingleType } from "~/strapi/api";
import { handleRequestError } from "~/utils/rollbar";
import SingleType from "../SingleType";
import Richtext from "~/components/Richtext";

type ServerSideProps = {
  page: StrapiCustomerService | null;
};

export const getServerSideProps: GetServerSideProps<ServerSideProps> = async (
  context
) => {
  const page = await findSingleType<StrapiCustomerService>(
    "customer-service"
  ).catch(handleRequestError(context.req, null));

  return {
    props: {
      page,
    },
  };
};

export default function CustomerServicePage({ page }: ServerSideProps) {
  return (
    <SingleType>
      <SingleType.Heading><span className="block text-center">Kundeservice</span></SingleType.Heading>
      {page?.attributes.content && (
        <SingleType.Content>
          <Richtext content={page.attributes.content} className="text-center" />
        </SingleType.Content>
      )}
    </SingleType>
  );
}
